export default __webpack_public_path__ + "static/media/calendly-logo-toolbox.2abdb132.svg";